// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"03bcb862","555":"2a18b8d9","869":"c9696e39"}[chunkId] + ".chunk.css";
};